<template>
  <v-app
    v-resize="onResize"
    id="inspire"
    class="grey lighten-4"
    :style="`width: ${windowSize.x}px; height: ${windowSize.y}px; overflow: auto;`"
  >
    <keep-alive>
      <NavigationDrawer v-if="token"/>
    </keep-alive>
    <ToolBar app fixed v-if="token"/>
    <v-content>
      <v-fade-transition mode="out-in">
        <router-view></router-view>
      </v-fade-transition>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import ToolBar from '@/components/toolbar/ToolBar'
import NavigationDrawer from '@/components/navigation/NavigationDrawer'

export default {
  name: 'App',
  components: {
    ToolBar,
    NavigationDrawer
  },
  data () {
    return {
      windowSize: {
        x: 0,
        y: 0
      }
    }
  },
  computed: {
    ...mapState('user', ['token'])
  },
  mounted () {
    this.onResize()
  },
  methods: {
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue